var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkout__vue__wrapper" }, [
    !_vm.isThankYou
      ? _c(
          "div",
          { staticClass: "checkout__vue" },
          [
            _c("Pagination", { attrs: { page: _vm.page } }),
            _vm._v(" "),
            _vm.page == 0
              ? _c("DateSelectView", {
                  attrs: {
                    checkoutData: _vm.checkoutDataClone,
                    "how-it-works": _vm.howItWorks,
                    nextPage: _vm.nextPage,
                    ajax: _vm.ajax,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.page == 1
              ? _c("CartView", {
                  attrs: {
                    checkoutData: _vm.checkoutDataClone,
                    nextPage: _vm.nextPage,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.page == 2
              ? _c("CustomerInformationView", {
                  attrs: {
                    checkoutData: _vm.checkoutDataClone,
                    order: _vm.order,
                    nextPage: _vm.nextPage,
                    prevPage: _vm.prevPage,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.page == 3
              ? _c("PaymentView", {
                  attrs: {
                    order: _vm.order,
                    imagePath: _vm.imagePath,
                    checkoutData: _vm.checkoutDataClone,
                    "agreement-url": _vm.agreementUrl,
                    "privacy-url": _vm.privacyUrl,
                    prevPage: _vm.prevPage,
                    reviews: _vm.reviews,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isThankYou
      ? _c(
          "div",
          { staticClass: "thank-you" },
          [
            _c("div", { staticClass: "thank-you__icon" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "27",
                    height: "29",
                    viewBox: "0 0 27 29",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M23.5683 6.5281C23.7953 6.78787 23.9172 7.13411 23.9072 7.49067C23.8972 7.84723 23.7561 8.18491 23.515 8.42947L10.3066 21.836C10.0373 22.109 9.67952 22.2578 9.30972 22.2504C8.93993 22.243 8.58749 22.0801 8.32781 21.7965L3.86393 16.9175C3.74572 16.7924 3.65181 16.6433 3.58765 16.4787C3.52349 16.3142 3.49038 16.1375 3.49023 15.959C3.49009 15.7806 3.52292 15.6039 3.58681 15.4392C3.65071 15.2745 3.74438 15.1252 3.86239 14.9999C3.9804 14.8746 4.12037 14.7758 4.27417 14.7094C4.42796 14.6429 4.5925 14.61 4.7582 14.6127C4.9239 14.6154 5.08745 14.6536 5.23932 14.725C5.3912 14.7964 5.52836 14.8996 5.64282 15.0287L9.36383 19.0951L21.8027 6.4707C22.0439 6.22622 22.3654 6.09494 22.6965 6.1057C23.0276 6.11646 23.3412 6.2684 23.5683 6.5281Z",
                      fill: "white",
                    },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.thankYouTxt
              ? [
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.thankYouTxt) },
                  }),
                ]
              : [
                  _c("h1", { staticClass: "title" }, [_vm._v("Bedankt!")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v(
                      "\n              Je ontvangt een mail met details over je boeking en de verdere stappen die je moet ondernemen. Voor\n              voorlopige\n              boekingen kan er nog contact met je opgenomen om een andere datum af te spreken. Je ontvangt een mail\n              wanneer\n              een voorlopige boeking is goedgekeurd.\n          "
                    ),
                  ]),
                ],
            _vm._v(" "),
            _c("a", { attrs: { href: "/online-trainingen" } }, [
              _c("div", { staticClass: "all-sessions-button" }, [
                _c("span", { staticClass: "all-sessions-button__text" }, [
                  _vm._v("Alle online trainingen"),
                ]),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "10",
                      height: "13",
                      viewBox: "0 0 10 13",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M0.857846 12.6298C0.954056 12.6798 1.06208 12.7027 1.17032 12.696C1.27855 12.6893 1.38292 12.6532 1.47222 12.5917L9.20392 7.239C9.28292 7.18426 9.34748 7.11119 9.39208 7.02605C9.43667 6.94091 9.45996 6.84623 9.45996 6.75012C9.45996 6.654 9.43667 6.55932 9.39208 6.47418C9.34748 6.38904 9.28292 6.31597 9.20392 6.26123L1.47222 0.908521C1.38299 0.846782 1.27857 0.810628 1.17027 0.803976C1.06197 0.797323 0.953918 0.820424 0.857805 0.870778C0.761691 0.921131 0.681185 0.996819 0.625001 1.08964C0.568818 1.18247 0.539099 1.2889 0.539063 1.3974V12.1028C0.539045 12.2114 0.568742 12.3179 0.624936 12.4108C0.68113 12.5037 0.761677 12.5794 0.857846 12.6298Z",
                        fill: "white",
                      },
                    }),
                  ]
                ),
              ]),
            ]),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Checkout/CheckoutView.vue